import React, { useState } from "react";
import logo1 from "../Images/logo1.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  const authToken = localStorage.getItem("authToken");

  return (
    <div className="navigation">
      <nav className="fixed w-full z-50 top-0 left-0 border-b border-gray-200 font-popins bg-white">
        <div className="max-w-screen-2xl flex flex-wrap items-center justify-between mx-auto p-4">
          <div className="flex gap-80 lg:flex-row flex-col ">
            <Link to="/main" className="flex items-center">
              <img src={logo1} className="h-14 mr-3" alt=" Logo" />
            </Link>
            <div className="items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-1">
              <ul className="flex flex-col p-4 lg:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 lg:flex-row lg:space-x-12 lg:mt-0 lg:border-0 lg:bg-white">
                <li>
                  <Link
                    to="/main"
                    className="font-normal py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                    aria-current="page"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features"
                    className="font-normal py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    Features
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    className="py-2 pl-3 pr-4 font-normal hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="py-2 pl-3 pr-4 nav-link font-normal hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    Feedback
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex lg:order-2">
            {authToken ? (
              <Link
                to="/dashboard"
                className="hidden lg:block  bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
              >
                Dashoabrd
              </Link>
            ) : (
              <Link
                to="/signin"
                className="hidden lg:block  bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
              >
                Start Your Journey
              </Link>
            )}

            <button
              data-collapse-toggle="navbar-sticky"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
              onClick={() => setNavOpen((prev) => !prev)}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>

          {navOpen ? (
            <div className="items-center justify-between lg:hidden w-full lg:w-auto lg:order-1">
              <ul className="flex flex-col p-4 lg:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 lg:flex-row lg:space-x-8 lg:mt-0 lg:border-0 lg:bg-white">
                <li>
                  <Link
                    to="/main"
                    className="py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                    aria-current="page"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features"
                    className="py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    Features
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    className="py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="py-2 pl-3 pr-4 nav-link hover:text-[#64748B] lg:p-0 transition-colors duration-300 nav-link"
                  >
                    Feedback
                  </Link>
                </li>
                {authToken ? (
                  <li className="mt-2 ml-2">
                    <Link
                      to="/dashboard"
                      className=" bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
                    >
                      Dashoabrd
                    </Link>
                  </li>
                ) : (
                  <li className="mt-2 ml-2">
                    <Link
                      to="/signin"
                      className=" bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
                    >
                      Start Your Journey
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          ) : null}
        </div>
      </nav>
      {/* its a chapii taka header fixed ka nicha jo space hai usa div daikr khali height dai dain */}
      <div className="h-20"></div>
    </div>
  );
};

export default Header;
